import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = { class: "row justify-end" }
const _hoisted_3 = { class: "column items-center q-mt-md" }
const _hoisted_4 = { class: "row q-mt-md" }

import { useRoute, useRouter } from 'vue-router'
import ShowAppointment from '@/components/ShowAppointment.vue';
import PayComponent from '@/components/PayComponent.vue';
import OrderSucess from '@/components/OrderSucess.vue';
import OrderPending from '@/components/OrderPending.vue';
import { doc, onSnapshot, getFirestore } from 'firebase/firestore'
import { ref, computed, onUnmounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PayPage',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const appointmentID = route.query.a != null ? String(route.query.a)  : undefined
const startDate = route.query.s != null ? new Date(Number(route.query.s)) : undefined
const duration = route.query.d != null ? Number(route.query.d) : 60
const time = route.query.t != null ? String(route.query.t) : String(Date.now())
const restBetrag = route.query.r != null ? Number(route.query.r) : undefined
const sessionType = route.query.o != null ? String(route.query.o) : 's'
const studio = route.query.studio != null ? String(route.query.studio).trim().toLowerCase() : ''
const studioDortmundParam = route.query.studioDortmund === '1' || route.query.studioDortmund === 'true' || route.query.do === '1' || route.query.do === 'true' || studio === 'dortmund'
const studioMalbert = route.query.m === '1' || route.query.m === 'true' || studio === 'malbert' || studioDortmundParam
const studioDortmund = studioDortmundParam || studioMalbert

const db = getFirestore()

const paymentStatus = ref<string | null>(null)
const isLoading = ref(false)

if (appointmentID && time) {
  const orderRef = doc(db, 'orders-status', `${appointmentID}__${time}`)

  const unsub = onSnapshot(orderRef, (snapshot) => {
    if (snapshot.exists()) {
      paymentStatus.value = snapshot.data().paymentStatus ?? null
    } else {
      paymentStatus.value = null
    }
  })

  onUnmounted(() => unsub())
}

const showPending = computed(() => isLoading.value && !isPaymentCompleted.value)
const isPaymentCompleted = computed(() => paymentStatus.value === 'Completed')

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_btn, {
          round: "",
          dense: "",
          flat: "",
          icon: "close",
          color: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        })
      ]),
      (_unref(startDate) && !isPaymentCompleted.value && !showPending.value)
        ? (_openBlock(), _createBlock(ShowAppointment, {
            key: 0,
            "start-date": _unref(startDate),
            duration: _unref(duration),
            "rest-betrag": _unref(sessionType) === 'o' ? undefined :_unref(restBetrag)
          }, null, 8, ["start-date", "duration", "rest-betrag"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (showPending.value)
          ? (_openBlock(), _createBlock(OrderPending, { key: 0 }))
          : _createCommentVNode("", true),
        (isPaymentCompleted.value && !showPending.value)
          ? (_openBlock(), _createBlock(OrderSucess, {
              key: 1,
              startDate: _unref(startDate),
              duration: _unref(duration)
            }, null, 8, ["startDate", "duration"]))
          : (_unref(appointmentID) != null && !showPending.value)
            ? (_openBlock(), _createBlock(PayComponent, {
                key: 2,
                appointmentID: _unref(appointmentID),
                duration: _unref(duration),
                time: _unref(time),
                sessionType: _unref(sessionType),
                "rest-betrag": _unref(restBetrag),
                "start-date": _unref(startDate),
                "studio-malbert": _unref(studioMalbert),
                "studio-dortmund": _unref(studioDortmund),
                "onUpdate:isLoading": _cache[1] || (_cache[1] = (val) => isLoading.value = val)
              }, null, 8, ["appointmentID", "duration", "time", "sessionType", "rest-betrag", "start-date", "studio-malbert", "studio-dortmund"]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_btn, {
            "no-caps": "",
            flat: "",
            size: "lg",
            color: "primary",
            label: "Back",
            icon: "arrow_back_ios",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).back()))
          })
        ])
      ])
    ]),
    _createVNode(_component_q_btn, {
      class: "row q-mt-md",
      "no-caps": "",
      flat: "",
      size: "sm",
      color: "primary",
      label: "Imprint and data protection",
      to: "/en/data-protection-imprint"
    })
  ], 64))
}
}

})